import { en, type UiResources } from './en.js';
import { tr } from './tr.js';

export type { UiResources };

/** Ortak metinler; uygulamalar kendi metinleriyle `withUiResources` ile birleştirir. */
export const uiResources = { en, tr } as const;

type Tree = { [key: string]: string | Tree };

function merge(base: Tree, extra: Tree): Tree {
  const out: Tree = { ...base };
  for (const [key, value] of Object.entries(extra)) {
    const current = out[key];
    // Diziler (ör. `help.<id>.steps`) birleştirilmez, uygulamanınki yerine geçer
    out[key] =
      typeof value === 'object' &&
      typeof current === 'object' &&
      !Array.isArray(value) &&
      !Array.isArray(current)
        ? merge(current, value)
        : value;
  }
  return out;
}

/**
 * Uygulamanın metinleri ortak metinlerin üstüne derin birleştirilir (CLAUDE.md "i18n"): aynı
 * anahtar varsa uygulamanınki kazanır.
 */
export function withUiResources(
  language: keyof typeof uiResources,
  app: object,
): Record<string, unknown> {
  return merge(uiResources[language] as unknown as Tree, app as Tree);
}
